<template>
  <div class="landing-wrapper">
    <v-container class="py-8 py-md-12" fluid>
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <v-alert v-if="error" type="error" class="mb-4" closable @click:close="error = ''">
            {{ error }}
          </v-alert>

          <div v-if="loading" class="d-flex justify-center py-8">
            <v-progress-circular indeterminate color="primary" size="48" />
          </div>

          <div v-else class="cia-panel">
            <div class="cia-panel-header">
              <v-icon size="22" color="#ffffff">mdi-clipboard-text-outline</v-icon>
              <span>LISTADO DE RESERVAS POR OBRAS</span>
            </div>

            <div class="cia-panel-body">
              <div class="cia-table-scroll">
                <table class="cia-table">
                  <thead>
                    <tr>
                      <th>NOMBRE</th>
                      <th>FECHA DE DISPONIBILIDAD</th>
                      <th>N° DE RESERVAS A LA FECHA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="p in plays"
                      :key="p.id"
                      class="cia-row-click"
                      @click="goToDetail(p)"
                    >
                      <td class="cia-cell-name">{{ p.title }}</td>
                      <td>{{ availability(p) }}</td>
                      <td>{{ p.reservationCount }} RESERVAS</td>
                    </tr>
                    <tr v-if="plays.length === 0">
                      <td colspan="3" class="cia-empty">
                        No hay obras registradas.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
import { fetchPlaysAdmin, fetchMyReservations } from "@/services/teatroApi";

export default {
  name: "ReservationsByPlay",
  data() {
    return {
      plays: [],
      loading: true,
      error: "",
    };
  },
  async created() {
    await this.loadAuth();
    await this.load();
  },
  methods: {
    async loadAuth() {
      try {
        await this.$store.dispatch("fetchIsAuthenticated");
      } catch (e) {
        console.error(e);
      }
    },
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const [plays, reservations] = await Promise.all([
          fetchPlaysAdmin(),
          fetchMyReservations(),
        ]);
        // Contar reservas (no canceladas) por obra.
        const counts = {};
        (reservations || []).forEach((r) => {
          const pid = r.play?.id;
          if (!pid) return;
          if (String(r.status).toLowerCase() === "cancelled") return;
          counts[pid] = (counts[pid] || 0) + 1;
        });
        this.plays = (plays || []).map((p) => ({
          ...p,
          reservationCount: counts[p.id] || 0,
        }));
      } catch (e) {
        this.error = "No se pudieron cargar las reservas por obra.";
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(iso) {
      if (!iso) return "";
      const [y, m, d] = String(iso).slice(0, 10).split("-");
      return `${d}/${m}/${y}`;
    },
    availability(p) {
      const start = this.formatDate(p.start_date);
      const end = this.formatDate(p.end_date);
      if (start && end) return `${start} - ${end}`;
      return start || end || "—";
    },
    goToDetail(p) {
      window.location.href = `/reservas/obra/${p.id}/`;
    },
  },
};
</script>

<style scoped>
.cia-panel {
  max-width: 1080px;
  margin: 0 auto;
  background: rgba(8, 5, 5, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.cia-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 66px;
  padding: 0 32px;
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.cia-panel-body {
  padding: 28px 34px 30px;
}

.cia-table-scroll {
  overflow-x: auto;
}

.cia-table {
  width: 100%;
  border-collapse: collapse;
  color: var(--color-theater-text);
  font-family: var(--font-family-heading);
}

.cia-table th {
  text-align: left;
  padding: 8px 16px 18px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;
}

.cia-table td {
  padding: 15px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  vertical-align: middle;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.cia-table tbody tr:first-child td {
  border-top: none;
}

.cia-cell-name {
  text-transform: uppercase;
}

.cia-row-click {
  cursor: pointer;
  transition: background 0.15s ease;
}

.cia-row-click:hover {
  background: rgba(255, 255, 255, 0.05);
}

.cia-empty {
  text-align: center;
  padding: 30px 16px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}
</style>
